
  import { Component, Vue ,Inject} from 'vue-property-decorator';
  import PageFooter from '@/components/page-footer.vue';
  @Component({  
    name: '',
    components: {
      PageFooter
    }
  })

  export default class ProductList extends Vue {
    @Inject() editinfo:any
    get editmsg(){
      return this.editinfo.msg
    }
  }
